import React from 'react';
import FileItem from './FileItem';

/**
 * FileList Component
 * 
 * Renders the attachments list with:
 * - Loading state
 * - Empty state
 * - File items with version history
 */
const FileList = ({
  isLoading,
  filteredAttachments,
  expandedVersions,
  onToggleVersions,
  onDownload,
  onDelete,
  onPreview,
  onRestore,
  onCompare,
}) => {
  if (isLoading) {
    return (
      <div className="attachments-modal__list">
        <div className="attachments-modal__loading">
          <div className="attachments-modal__spinner" />
          <span>Loading attachments...</span>
        </div>
      </div>
    );
  }

  if (filteredAttachments.length === 0) {
    return (
      <div className="attachments-modal__list">
        <div className="attachments-modal__empty">
          <div className="attachments-modal__empty-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
              <polyline points="13 2 13 9 20 9" />
            </svg>
          </div>
          <span className="attachments-modal__empty-text">No attachments yet</span>
          <span className="attachments-modal__empty-hint">
            Drag files here or click the upload area above
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="attachments-modal__list">
      {filteredAttachments.map(file => (
        <FileItem
          key={file.id}
          file={file}
          isVersionsExpanded={expandedVersions.has(file.id)}
          onToggleVersions={onToggleVersions}
          onDownload={onDownload}
          onDelete={onDelete}
          onPreview={onPreview}
          onRestore={onRestore}
          onCompare={onCompare}
        />
      ))}
    </div>
  );
};

export default FileList;
